module.exports = __webpack_public_path__ + "static/media/aragon01.0bb634d2.jpg";